<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>Spefüxe</v-card-title>
    <v-card-text class="pa-0">
      <div class="body-2 pa-4" v-if="bbrbbr.length === 0">Keine Spefüxe eingetragen</div>
      <v-simple-table dense fixed-header>
        <tbody>
          <tr v-for="item in bbrbbr" :key="item.id" v-on:dblclick="(bbr = item) && (showKontakt = true)">
            <td>{{ item.nachname }}, {{ item.vorname }}</td>
            <td width="20px" v-on:click="(bbr = item) && (showKontakt = true)"><v-icon>info</v-icon></td>
          </tr>
          <tr>
            <td colspan="3" class="text-center">
              <v-btn block @click="showKontaktNeu = true" text><v-icon>add</v-icon></v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
      <dialogKontaktCreate :visible.sync="showKontaktNeu" :status="'Spefux'" @close="showKontaktNeu = false"></dialogKontaktCreate>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        bbr: {},
        showKontakt: false,
        showKontaktNeu: false
      }
    },
    computed: {
      bbrbbr () {
        return this.$store.getters['bbrbbr/bbrStatus']('Spefux')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// keilkandidaten.vue?dc115886